import { Box } from "theme-ui";
import { Breadcrumbs } from "@smerth/gatsby-theme-theme-ui";
import breadcrumbsData from "../../../../documentation/data/breadcrumbs.yaml";
import * as React from 'react';
export default {
  Box,
  Breadcrumbs,
  breadcrumbsData,
  React
};